import React, { useCallback, useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import InterventionOrder from './InterventionOrder';
import useInterventionOrder from 'src/hooks/api/useInterventionOrder';
import { PostInterventionOrderBody } from 'src/interfaces/api/InterventionOrder';
import Site from 'src/interfaces/api/Site';
import moment from 'moment';
import { Box, Card, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const InterventionOrderContainer = ({ location: { search }, history }) => {
  const [site, setSite] = useState<Partial<Site>>();
  const [provider, setProvider] = useState<string>();
  const [contact, setContact] = useState<string>('');
  const [ticketId, setTicketId] = useState<string>();
  const [domainId, setDomainId] = useState<string>();
  const [authToken, setAuthToken] = useState<string>();
  const [isExpired, setIsExpired] = useState(false);

  const { create } = useInterventionOrder();

  const handleCreate = useCallback(
    (interventionOrder: PostInterventionOrderBody) => {
      return create({ ...interventionOrder, providerId: provider, token: authToken }, true);
    },
    [provider]
  );

  const goToSuccessPage = useCallback(() => {
    history.push(
      "/informations?title=Bon d'intervention&message=Votre bon d'intervention a bien été créé&type=success"
    );
  }, [history]);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const token = searchParams.get('token');
    if (token) {
      const json: any = jwtDecode(token);
      const authToken: any = jwtDecode(json.token);

      setIsExpired(moment().isAfter(moment(authToken.expirationDate)));
      setContact(json.contact);
      setAuthToken(json.token);
      setProvider(json.providerId);
      setTicketId(json.ticketId);
      setDomainId(json.domainId);
      setSite({
        socialReason: json.socialReason,
        address: json.address,
        postalCode: json.postalCode,
        city: json.city,
      });
    }
  }, [search]);

  if (!ticketId || !site) {
    return null;
  }

  if (isExpired) {
    return (
      <Box m={4} clone>
        <Card>
          <Box m={2}>
            <Typography gutterBottom variant='h5' component='h2'>
              Bon d'intervention
            </Typography>
            <Alert severity='error'>Le lien est expiré</Alert>
          </Box>
        </Card>
      </Box>
    );
  }

  return (
    <InterventionOrder
      site={site}
      ticketId={ticketId}
      contact={contact}
      isTicketTelecom={domainId !== 'a5dc2e57-367e-4b29-a8ea-8fa266dbe523'}
      onSaveInterventionOrder={handleCreate}
      onSuccess={goToSuccessPage}
    />
  );
};

export default InterventionOrderContainer;
